import { ColumnsType } from 'antd/es/table';
import dayjs from 'dayjs';
import { Link } from 'react-router-dom';
import { formatAmount } from '../../../../common/utils/common.utils';
import { ICollectionTypeResult } from './CollectionTypes';

export const CollectionColumn = (): ColumnsType<ICollectionTypeResult> => {
  return [
    {
      title: 'SL.',
      render: (_, data, index) => <>{index + 1}</>,
    },
    {
      title: 'Received Date',
      key: 'receipt_payment_date',
      render: (_, record) => {
        return `${dayjs(record.receipt_payment_date).format('DD MMM YYYY')}`;
      },
    },
    {
      title: 'Receipt No.',
      dataIndex: 'receipt_vouchar_no',
      key: 'receipt_vouchar_no',
    },
    {
      title: 'Account Name',
      dataIndex: 'account_name',
      key: 'account_name',

      render: (curr, data) => {
        const { account_id } = data;
        return (
          <Link
            to={`/accounts/account_statement/${account_id}`}
            state={`/accounts/account_statement/${account_id}`}
          >
            {curr}
          </Link>
        );
      },
    },

    {
      title: 'Client Name',
      dataIndex: 'client_name',
      key: 'client_name',

      render: (curr, record) => {
        const { client_id, combine_id } = record;

        return (
          <Link
            to={
              client_id
                ? `/reports/client_ledger?client_query=${client_id}`
                : `/reports/combined_ledger?id=${combine_id}`
            }
          >
            <span>{curr}</span>
          </Link>
        );
      },
    },
    {
      title: 'Pay to',
      dataIndex: 'receipt_payment_to',
      key: 'receipt_payment_to',
    },
    {
      title: 'Pay Method',
      dataIndex: 'acctype_name',
      key: 'acctype_name',
    },
    {
      title: 'Bank Name',
      dataIndex: 'bank_name',
      key: 'bank_name',
    },

    {
      title: 'Received Amount',
      dataIndex: 'receipt_total_amount',
      key: 'receipt_total_amount',
      align: 'right',
      render: (curr) => <span className='color-collection'>{formatAmount(curr)}</span>,
    },
    {
      title: 'Received By',
      dataIndex: 'employee_full_name',
      key: 'employee_full_name',
      align: 'right',
    },
    {
      title: 'Prepared By',
      dataIndex: 'user_full_name',
      key: 'user_full_name',
      align: 'right',
    },
  ];
};

export const BankSummaryColumn = (): ColumnsType<{
  bank_name: string;
  total_receipt: string;
}> => {
  return [
    {
      title: 'SL.',
      render: (_, data, index) => <>{index + 1}</>,
    },
    {
      title: 'Bank name',
      dataIndex: 'bank_name',
      key: 'bank_name',
      render: (curr) => (curr ? curr : 'N/A'),
    },
    {
      title: 'Total received',
      dataIndex: 'total_receipt',
      key: 'total_receipt',
      align: 'end',
      render: (curr) => formatAmount(curr),
    },
  ];
};
